import moment from "moment";

type Config = {
  dataset: Array<any>;
  filterSelected: string;
  value: string;
};

const getBeforeDateItems = (dataset: Array<any>, value: any): Array<Object> =>
  dataset.filter((item) => {
    return moment(item.createdAt, "DD/MM/YYYY").isBefore(value);
  });

const getSameDateItems = (dataset: Array<any>, value: Object): Array<Object> =>
  dataset.filter((item) => {
    return moment(item.createdAt, "DD/MM/YYYY").isSame(value);
  });

const getAfterDateItems = (dataset: Array<any>, value: Object): Array<Object> =>
  dataset.filter((item) => {
    return moment(item.createdAt, "DD/MM/YYYY").isAfter(value);
  });

const filterWithDate = (config: Config, DATE_TYPES: any): Array<Object> => {
  const { filterSelected, dataset, value } = config;

  let datasetFilteredByDate = [];

  const valueFormatted = moment(value, "DD/MM/YYYY");

  if (filterSelected === DATE_TYPES.BEFORE) {
    datasetFilteredByDate = getBeforeDateItems(dataset, valueFormatted);
  }

  if (filterSelected === DATE_TYPES.SAME) {
    datasetFilteredByDate = getSameDateItems(dataset, valueFormatted);
  }

  if (filterSelected === DATE_TYPES.AFTER) {
    datasetFilteredByDate = getAfterDateItems(dataset, valueFormatted);
  }

  return datasetFilteredByDate;
};

export const getTimeDiff = (end, startTime) => {
  var duration = moment.duration(moment(startTime).diff(end));
  return duration.asMinutes().toFixed(2) + " m";
};

export default filterWithDate;
